// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__259Jm","productName":"Table_productName__1ynvB"};